export enum Continent {
	Other,
	Europe,
}
